window.addEventListener('DOMContentLoaded', (event) => {
    scrollToTopOfLeather();
  });
  
  // !!!! Begin hover fade items interaction
  // ################################
  const fadeTriggers = document.querySelectorAll("[data-fade-trigger]");
  const fadeItems = document.querySelectorAll("[data-fade-item]");
  const fadeParent = document.querySelector("[data-fade-parent]");
  
  initialState();
  
  function initialState() {
    if (fadeItems[0].classList.contains("active") === false) {
      fadeItems[0].classList.add("active");
      setTimeout(() => {
        fadeItems[0].style.opacity = "1";
      }, 150)
    }  
  
    if (fadeTriggers[0].classList.contains("active") === false) {
      fadeTriggers[0].classList.add("active");
    }
  }
  
  fadeTriggers.forEach((trigger, trigIndex) => {
    function setupClasses(trigger) {
      fadeTriggers.forEach((trigger) => {
        trigger.classList.remove("active");
      });
      fadeItems.forEach((fadeItem, itemIndex) => {
        if (fadeItem.classList.contains("active")) {
          fadeItem.classList.remove("active");
          setTimeout(() => {
            fadeItem.style.opacity = "0";
          }, 150)
        }
        if (trigIndex === itemIndex) {
          fadeItem.classList.add("active");
          setTimeout(() => {
            fadeItem.style.opacity = "1";
          }, 150)
        }
      });
      trigger.classList.add("active");
    }
  
    // SETUP EVENTS
    // if it's desktop
    if (window.innerWidth >= 992) {
      trigger.addEventListener("mouseenter", () => {
        setupClasses(trigger);
      });
    }
    if (window.innerWidth >= 992 && window.innerWidth < 2200) {
      // setParentHeight();
    }
  
    // if it's tablet only
    if (window.innerWidth <= 991 && window.innerWidth > 767) {
      trigger.addEventListener("click", () => {
        setupClasses(trigger);
      });
      // setParentHeight();
    }
  });
  
  function setParentHeight() {
    // set container height to height of tallest item child
    // check highest number in array
    let fadeItemsHeight = [0];
    let largest = fadeItemsHeight[0];
  
    fadeItems.forEach((item) => {
      let itemHeight = item.offsetHeight;
      fadeItemsHeight.push(itemHeight);
    });
  
    for (let i = 0; i < fadeItemsHeight.length; i++) {
      if (largest < fadeItemsHeight[i] || largest === fadeItemsHeight[i]) {
        largest = fadeItemsHeight[i];
      }
    }
    fadeParent.style.height = `${largest}px`;
  }
  // !!!! End hover fade items interaction
  // ################################
  
  // ################################
  // !!!! Begin accordion
  
  var accordion = (function () {
    var $accordion = $(".js-accordion");
    var $accordion_header = $accordion.find(".js-accordion-header");
    var $accordion_item = $(".js-accordion-item");
  
    // default settings
    var settings = {
      // animation speed
      speed: 400,
  
      // close all other accordion items if true
      oneOpen: false
    };
  
    return {
      // pass configurable object literal
      init: function ($settings) {
        $accordion_header.on("click", function () {
          accordion.toggle($(this));
        });
  
        $.extend(settings, $settings);
  
        // ensure only one accordion is active if oneOpen is true
        if (settings.oneOpen && $(".js-accordion-item.active").length > 1) {
          $(".js-accordion-item.active:not(:first)").removeClass("active");
        }
  
        // reveal the active accordion bodies
        $(".js-accordion-item.active").find("> .js-accordion-body").show();
      },
      toggle: function ($this) {
        if (
          settings.oneOpen &&
          $this[0] !=
            $this
              .closest(".js-accordion")
              .find("> .js-accordion-item.active > .js-accordion-header")[0]
        ) {
          $this
            .closest(".js-accordion")
            .find("> .js-accordion-item")
            .removeClass("active")
            .find(".js-accordion-body")
            .slideUp();
        }
  
        // show/hide the clicked accordion item
        $this.closest(".js-accordion-item").toggleClass("active");
        $this.next().stop().slideToggle(settings.speed);
      }
    };
  })();
  
  $(document).ready(function () {
    accordion.init({ speed: 300, oneOpen: true });
  });
  
  // !!!! End accordion
  // ################################
  
  // ################################
  // !!!! Begin semelles sliders
  
  var solesSwiperLeft = new Swiper(".swiper.soles-left", {
    threshold: 1,
    speed: 1300,
    resistanceRatio: 1,
    observer: true,
    keyboard: { enabled: true },
    observeParents: true,
    allowTouchMove: false,
    breakpoints: {
      // when window width is >= 320px
      992: {
        spaceBetween: 50
      },
      // when window width is >= 320px
      320: {
        spaceBetween: 50,
        allowTouchMove: true,
      }
    },
    navigation: {
      nextEl: "#sole-slider-next",
      prevEl: "#sole-slider-prev"
    }
  });
  
  var solesSwiperRight = new Swiper(".swiper.soles-right", {
    threshold: 1,
    speed: 1300,
    resistanceRatio: 1,
    observer: true,
    keyboard: { enabled: true },
    observeParents: true,
    breakpoints: {
      // when window width is >= 768px
      768: {
        allowTouchMove: false,
      },
      // when window width is >= 320px
      320: {
        spaceBetween: 50,
        allowTouchMove: true,
      }
    },
  });
  
  
  
  solesSwiperLeft.controller.control = solesSwiperRight;
  solesSwiperRight.controller.control = solesSwiperLeft;
  
  // !!!! End semelles sliders
  
  // ################################
  // ################################
  // !!!! Begin process sliders
  var processSwiperLeft = new Swiper(".swiper.process-slider-left", {
    threshold: 1,
    speed: 1300,
    resistanceRatio: 1,
    observer: true,
    keyboard: { enabled: true },
    observeParents: true,
    allowTouchMove: false,
    navigation: {
      nextEl: "#process-slider-next",
      prevEl: "#process-slider-prev"
    }
  });
  
  var processSwiperRight = new Swiper(".swiper.process-slider-right", {
    threshold: 1,
    speed: 1300,
    resistanceRatio: 1,
    observer: true,
    keyboard: { enabled: true },
    observeParents: true,
    allowTouchMove: false,
    breakpoints: {
      // when window width is >= 768px
      992: {
        allowTouchMove: false,
      },
      // when window width is >= 320px
      320: {
        spaceBetween: 50,
        allowTouchMove: true,
      }
    },
  });
  
  
  processSwiperLeft.controller.control = processSwiperRight;
  processSwiperRight.controller.control = processSwiperLeft;
  
  // !!!! End process sliders
  // ################################
  
  
  let leatherItems = document.querySelectorAll('[data-cuir-acc-item]');
  function scrollToTopOfLeather() {
    leatherItems.forEach(leatherItem => {
      leatherItem.addEventListener('click', () => {
        setTimeout(() => {
          gsap.to(window, {duration: 1, scrollTo: {y: leatherItem, offsetY: 70}, ease: "power2.inOut"});
        }, 400)
      })
    });
  }